<template>
  <div class="reports-index">
    <h3 v-if="$store.state.project.plan ">{{ $store.state.project.plan.name }}</h3>
    <div class="reports-ul" v-if="!$store.state.project.version || !$store.state.project.version.id">

      <router-link
        :to="report.route === 'ONE_REPORT' ? '/dashboard/one-reports' : `/dashboard/reports/${report.route}`"
        v-for="(report, i) in reports"
        :key="i"
        v-if="available_reports[report.route] || report.isShow"
        class="reports-li"
      >
        <span>
          <img :src="report.icon" class="icon-menu"/>
          {{ report.label }}</span> <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>
    <div v-else style="max-width: 320px; margin: 0 auto">
      <h3 style="font-weight: normal">Выгрузить отчет по работам</h3>
      <div>
        <date-picker
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRangeDownload"
          range
        ></date-picker>
        <el-row>
          <el-col :span="12">
            <el-checkbox v-model="downloadForAll" style="margin-top: 10px">За все время</el-checkbox>
          </el-col>
        </el-row>
        <a :href="getHref" target="_blank">
          <el-button type="primary" style="width: 100%; margin-top: 10px" class="reports-li">
            Выгрузить
          </el-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import DatePicker from "vue2-datepicker";
import {apiUrl} from "../../../plugins/firebase";
import firebase from "firebase";

export default {
  name: 'Index',
  components: {DatePicker},

  mounted() {
    const available_reports = this.$store.state.project.available_reports || {};


    localStorage.removeItem('JOB' + '_' + this.$store.state.project.id);
    localStorage.removeItem('PROF' + '_' + this.$store.state.project.id);
    localStorage.removeItem('TECH' + '_' + this.$store.state.project.id);
    localStorage.removeItem('ONE_REPORT' + '_' + this.$store.state.project.id);
    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }
  },
  computed: {
    getHref() {


      let path = 'onGenerateFactJobs'

      const params = encodeURIComponent(`/${path}/${this.$store.state.project.id}`)
      let url = `${apiUrl}${params}&queryParams=uid=${this.$store.state.company.uid || this.$store.state.company.id || firebase.auth().currentUser.uid}`;

      if (!this.downloadForAll) {
        url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}, toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
      }

      return url + ', version=' + this.$store.state.project.version && this.$store.state.project.version.id;
    },
  },
  data() {
    return {
      datetimeRangeDownload: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      downloadForAll: false,
      type_select: 'JOB',
      available_reports: {
        JOB: true,
        TECH: true,
        PROF: true,
        COVID: true,
        WILD_PIPE: false,
        MATERIALS: false,
        MAIN: false,
        TASKS: true,
        ONE_REPORT: false,
      },
      reports: [
        {
          label: 'Единый отчет',
          route: 'ONE_REPORT',
          icon: require('@/assets/icon/report-work.svg'),
        },
        {
          label: 'Общие отчеты по работам',
          route: 'MAIN',
          icon: require('@/assets/icon/report-all-work.svg'),
        },
        {
          label: 'Общие отчеты с материалами',
          route: 'MATERIALS',
          icon: require('@/assets/icon/report-material.svg'),
        },
        {
          label: 'Отчеты по работам',
          route: 'JOB',
          icon: require('@/assets/icon/report-work.svg'),
        },
        {
          label: 'Отчеты по численности',
          route: 'PROF',
          icon: require('@/assets/icon/report-number.svg'),
        },
        {
          label: 'Отчеты по технике',
          route: 'TECH',
          icon: require('@/assets/icon/report-technician.svg'),
        },
        {
          label: 'Отчет по сварке трубопроводов',
          route: 'WILD_PIPE',
          icon: require('@/assets/icon/pipe-report.svg'),
        },
        {
          label: 'Табель',
          route: 'TABEL',
          icon: require('@/assets/icon/report-work.svg'),
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 400px;
  padding-top: 20px;
}


.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .reports-li {
    span {
      display: flex;
      align-items: center;
    }
    img {
      margin-right: 8px;
    }
  }

  .reports-li, > > > .reports-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;
    text-decoration: none;
    color: #000;

    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/Index.vue